import React, { useState } from "react";
import { ADMIN_OPTIONS, DEFAULT_ADMIN } from "../config/admins";
import { createPartnerUsers } from "../api/partner";

interface AddClientProps {
  onBack: () => void;
}

export default function AddClient({ onBack }: AddClientProps) {
  const [adminUuid, setAdminUuid] = useState(DEFAULT_ADMIN.uuid);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [credits, setCredits] = useState(100);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<{
    type: "success" | "error";
    message: string;
  } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setResult(null);
    setLoading(true);

    try {
      const response = await createPartnerUsers({
        admin_uuid: adminUuid,
        app: "wine",
        default_password: password,
        users: [{ email, password, credits }],
      });

      if (response.ok) {
        setResult({
          type: "success",
          message: `Le client ${email} a ete cree avec succes.`,
        });
        setEmail("");
        setPassword("");
      } else {
        setResult({
          type: "error",
          message: response.message || "Une erreur est survenue",
        });
      }
    } catch (err: any) {
      setResult({
        type: "error",
        message: err.message || "Erreur reseau",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <button onClick={onBack} style={styles.backBtn}>
            &larr; Retour
          </button>
          <h2 style={styles.title}>Ajouter un client</h2>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          <label style={styles.label}>
            Organisation
            <select
              value={adminUuid}
              onChange={(e) => setAdminUuid(e.target.value)}
              style={styles.select}
            >
              {ADMIN_OPTIONS.map((admin) => (
                <option key={admin.uuid} value={admin.uuid}>
                  {admin.name}
                </option>
              ))}
            </select>
          </label>

          <label style={styles.label}>
            Email du client
            <input
              type="email"
              placeholder="client@exemple.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={styles.input}
            />
          </label>

          <label style={styles.label}>
            Mot de passe
            <input
              type="text"
              placeholder="Mot de passe initial pour le client"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={styles.input}
            />
          </label>

          <label style={styles.label}>
            Credits
            <input
              type="number"
              min={1}
              value={credits}
              onChange={(e) => setCredits(parseInt(e.target.value) || 0)}
              required
              style={styles.input}
            />
          </label>

          {result && (
            <p
              style={
                result.type === "success" ? styles.success : styles.error
              }
            >
              {result.message}
            </p>
          )}

          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? "Creation en cours..." : "Creer le client"}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: 8,
    padding: 40,
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    width: 480,
  },
  header: {
    marginBottom: 24,
  },
  backBtn: {
    background: "none",
    border: "none",
    color: "#4f46e5",
    fontSize: 14,
    cursor: "pointer",
    padding: 0,
    marginBottom: 8,
  },
  title: {
    margin: 0,
    fontSize: 22,
    color: "#333",
  },
  form: {
    display: "flex",
    flexDirection: "column" as const,
    gap: 16,
  },
  label: {
    display: "flex",
    flexDirection: "column" as const,
    gap: 4,
    fontSize: 13,
    fontWeight: 600,
    color: "#555",
  },
  input: {
    padding: "10px 14px",
    border: "1px solid #ddd",
    borderRadius: 6,
    fontSize: 14,
    fontWeight: 400,
    outline: "none",
  },
  select: {
    padding: "10px 14px",
    border: "1px solid #ddd",
    borderRadius: 6,
    fontSize: 14,
    fontWeight: 400,
    outline: "none",
    backgroundColor: "#fff",
  },
  button: {
    padding: "12px 16px",
    backgroundColor: "#4f46e5",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    marginTop: 8,
  },
  success: {
    color: "#16a34a",
    fontSize: 13,
    margin: 0,
    padding: "8px 12px",
    backgroundColor: "#f0fdf4",
    borderRadius: 6,
  },
  error: {
    color: "#dc2626",
    fontSize: 13,
    margin: 0,
    padding: "8px 12px",
    backgroundColor: "#fef2f2",
    borderRadius: 6,
  },
};
